export default __webpack_public_path__ + "static/media/celebrate.a8db2b72.svg";